import Icon from '../components/Icon.vue'

Icon.register({
  angry: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM136 240C136 230.7 140.1 222.5 146.5 216.6L115.5 207.3C107 204.8 102.2 195.8 104.8 187.4 107.3 178.9 116.2 174.2 124.7 176.7L204.7 200.7C213.2 203.2 218 212.2 215.4 220.6 213.3 227.5 207 232 200.1 232 199.6 232 199 231.8 198.4 231.8 199.1 234.5 200.1 237.1 200.1 240 200.1 257.7 185.8 272 168.1 272S136 257.7 136 240zM304 394.2C276.2 360.8 219.8 360.8 191.9 394.2 178.4 410.5 153.7 390 167.3 373.7 187.3 349.7 216.7 335.9 247.9 335.9S308.5 349.7 328.5 373.7C342.3 390.2 317.4 410.3 304 394.2zM380.6 207.3L349.6 216.6C355.9 222.4 360.1 230.7 360.1 240 360.1 257.7 345.8 272 328.1 272S296.1 257.7 296.1 240C296.1 237.1 297 234.4 297.8 231.8 297.2 231.9 296.7 232 296.1 232 289.2 232 282.9 227.5 280.8 220.6 278.3 212.1 283.1 203.2 291.5 200.7L371.5 176.7C379.9 174.2 388.9 179 391.4 187.4 393.9 195.9 389.1 204.8 380.6 207.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angry.js
// module id = EQYM
// module chunks = 144